import React from 'react';
import { GuideElement, ArrowElement, HighlightElement, LabelElement } from '../../types/arGuides';
import { AnimatedArrow } from './AnimatedArrow';
import { PulsingHighlight } from './PulsingHighlight';
import { FloatingLabel } from './FloatingLabel';

interface SVGElementRendererProps {
  element: GuideElement;
}

export const SVGElementRenderer: React.FC<SVGElementRendererProps> = ({ element }) => {
  if (element.type === 'arrow') {
    return <AnimatedArrow arrow={element as ArrowElement} />;
  }
  if (element.type === 'highlight') {
    return <PulsingHighlight highlight={element as HighlightElement} />;
  }
  if (element.type === 'label') {
    return <FloatingLabel label={element as LabelElement} />;
  }
  return null;
};
